import type { ICustomControlDiagnosticReportReadProps } from '../../../interfaces/customControlDiagnosticReportReadProps';
import { getDisplayName } from '../../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../../translate';
import { DiagnosticReportReadButtons } from '../../../../../elements/carePathButtons/DiagnosticReportReadButtons';
import { FormDivider, UserTextParagraph } from '../../../../../elements/common';
import { FormLabel } from '../../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../../elements/forms/InputContainer';
import { ProcessContainer } from '../../../../episodes/common';
import { ProcessItemFooter } from '../../../../episodes/ProcessItemFooter';
import { ProcessItemHeader } from '../../../../episodes/ProcessItemHeader';
import { CustomControlCollapseBody } from '../../../utils/v1/CustomControlCollapseBody';
import { DiagnosticReportThumbnails } from '../../../utils/v1/DiagnosticReportThumbnails';
import { PilotConsultationV1DiagnosticReportSummary } from './PilotConsultationV1DiagnosticReportSummary';

export function PilotConsultationV1DiagnosticReportRead(props: ICustomControlDiagnosticReportReadProps) {
    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.diagnosticReport && props.diagnosticReport.dateSent}
                isFirstItem={props.isFirstItem}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                organizationName={props.diagnosticReport.performerOrganization?.name}
                practitionerName={
                    props.diagnosticReport.performerPractitioner
                        ? getDisplayName(props.diagnosticReport.performerPractitioner)
                        : undefined
                }
                process={props.process}
                title={translateKey('diagnosticReport.category_consultReport')}
            />

            <PilotConsultationV1DiagnosticReportSummary {...props} />

            <CustomControlCollapseBody isOpen={props.itemState.isOpen}>
                <FormDivider />

                <DiagnosticReportThumbnails {...props} />

                {props.diagnosticReport.customControlData.bevindingen && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('diagnosticReport.findings')}</FormLabel>
                        <InputContainer>
                            <UserTextParagraph>
                                {props.diagnosticReport.customControlData.bevindingen}
                            </UserTextParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}

                {props.diagnosticReport.customControlData.toelichting_bevindingen && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('diagnosticReport.remarks')}</FormLabel>
                        <InputContainer>
                            <UserTextParagraph>
                                {props.diagnosticReport.customControlData.toelichting_bevindingen}
                            </UserTextParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}
            </CustomControlCollapseBody>

            <ProcessItemFooter
                isItemOpen={props.itemState.isOpen}
                labelLess={translateKey('diagnosticReport.hideConsultReport')}
                labelMore={translateKey('diagnosticReport.showConsultReport')}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
            />
            <DiagnosticReportReadButtons {...props} />
        </ProcessContainer>
    );
}
